export const FAVORITES_QUERY = 'favourites';
